import { Box, FormControl, TextField } from "@mui/material";
import ManageEditorsControl from "../ManageStudy/ManageEditorsControl";
import Dropdown from "./DropDown";
import { useAddStudyStore } from "./useAddStudyStore";

export default function NewStudy() {
  const {
    studyType,
    setStudyType,
    vendorName,
    setVendorName,
    studyName,
    setStudyName,
    therapeuticArea,
    setTherapeuticArea,
    brand,
    setBrand,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    vendorArray,
    theraputicArerArray,
    brandArray,
    editorArray,
    setEditorsArray,
  } = useAddStudyStore();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "60%",
          height: "auto",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <FormControl
            size="medium"
            variant="outlined"
            fullWidth
            sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <Dropdown
              label="*Study Type"
              array={["Quantitative", "Qualitative"]}
              value={studyType}
              onChange={(value) => {
                setStudyType(value);
              }}
            />
            <Dropdown
              label="*Vendor Name"
              array={vendorArray ?? []}
              value={vendorName}
              onChange={(value) => {
                setVendorName(value);
              }}
            />
            <TextField
              label="*Study Name"
              variant="outlined"
              required
              value={studyName}
              onChange={(e) => setStudyName(e.target.value)}
            />
            <Dropdown
              label="*Therapeutic Area"
              array={theraputicArerArray ?? []}
              value={therapeuticArea}
              onChange={(value) => setTherapeuticArea(value)}
            />
            <Dropdown
              label="*Product | Brand"
              array={brandArray ?? []}
              value={brand}
              onChange={(value) => setBrand(value)}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1,
                width: "100%",
                gap: "1rem",
              }}
            >
              <TextField
                label="Start Date"
                variant="outlined"
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
                type="date"
                inputProps={{ pattern: "\\d{2}-\\d{2}-\\d{4}", placeholder: "MM-DD-YYYY" }}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setEndDate("");
                }}
                value={startDate}
              />
              -
              <TextField
                label="End Date"
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={endDate}
                type="date"
                inputProps={{ pattern: "\\d{2}-\\d{2}-\\d{4}", placeholder: "MM-DD-YYYY" }}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Box>
          </FormControl>

          <ManageEditorsControl
            editors={editorArray?.map((_) => _.display_name) ?? []}
            onSaveEditors={setEditorsArray}
          />
        </Box>
      </Box>
    </Box>
  );
}
